<template>
	<v-dialog v-model="dialog" persistent max-width="400" scrollable content-class="rounded-xl">
		<v-card>
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-xs-12 font-size-13 cl-primary font-weight-bold">Alamat Pengiriman</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="pt-3">
				<v-col class="px-0 cl-secondary font-size-11 font-weight-500 border-grey">
					<v-form ref="formAddress">
						<v-row>
							<v-col cols="12">
								<v-text-field hide-details="auto" label="Nama Penerima" color="primary" :rules="rules.name" required v-model="params.receiver_name" ref="receiver_name"></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field hide-details="auto" label="Nomor Handphone" color="primary" :rules="[...rules.phone, ...rules.phone_two, ...rules.phone_three]" required v-model="params.receiver_phone" @keypress="onlyNumber"></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-autocomplete hide-details="auto" label="Provinsi" color="primary" no-data-text="Belum ada data yang dapat ditampilkan" :rules="rules.provinces" required :items="provinces" item-text="province_name" item-value="province_id" return-object v-model="params.receiver_province" @change="getCityAddress"></v-autocomplete>
							</v-col>
							<v-col cols="12">
								<v-autocomplete hide-details="auto" label="Kota/Kabupaten" color="primary" no-data-text="Pilih Provinsi terlebih dahulu" :rules="rules.cities" required :items="cities" item-text="city_name" item-value="city_id" return-object v-model="params.receiver_city" @change="getSubdistrictAddress">
									<!-- <template v-slot:item="data">
										<div><span>{{ data.item.city_type }} </span><span>{{ data.item.city_name }}</span></div>
									</template>
									<template v-slot:selection="data">
										<div><span>{{ data.item.city_type }} </span><span>{{ data.item.city_name }}</span></div>
									</template> -->
								</v-autocomplete>
							</v-col>
							<v-col cols="12">
								<v-autocomplete hide-details="auto" label="Kecamatan" color="primary" no-data-text="Pilih Kota/Kabupaten terlebih dahulu" :rules="rules.subdistricts" required :items="subdistricts" item-text="subdistrict_name" item-value="subdistrict_id" return-object v-model="params.receiver_subdistrict"></v-autocomplete>
							</v-col>
							<v-col cols="12">
								<v-textarea hide-details="auto" label="Alamat Lengkap" color="primary" rows="3" no-resize :rules="rules.address" required v-model="params.receiver_address"></v-textarea>
							</v-col>
						</v-row>
					</v-form>
				</v-col>
			</v-card-text>
			<v-card-actions class="justify-center">
				<v-col cols="5" class="text-center">
					<v-btn depressed color="primary" height="45" class="white--text rounded-xl text-capitalize font-weight-bold" @click="saveAddress">
						<span class="pr-2 font-size-xs-10 font-size-11">Simpan</span>
						<v-icon>mdi-content-save-outline</v-icon>
					</v-btn>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	data () {
		return {
			dialog: false,
			btn_disabled: true,
			rules: {
				name: [v => !!v || 'Nama Penerima tidak boleh kosong'],
				phone: [v => !!v || 'Nomor Handphone tidak boleh kosong'],
				phone_two: [v => v.length > 7 || 'Nomor Handphone minimal 8 karakter'],
				phone_three: [v => v.length <= 15 || 'Nomor Handphone maksimal 15 karakter'],
				provinces: [v => !!v || 'Provinsi tidak boleh kosong'],
				cities: [v => !!v || 'Kota/Kabupaten tidak boleh kosong'],
				subdistricts: [v => !!v || 'Kecamatan tidak boleh kosong'],
				address: [v => !!v || 'Alamat lengkap tidak boleh kosong'],
			},
			params: {
				receiver_name: '',
				receiver_phone: '',
				receiver_address: '',
				receiver_province: '',
				receiver_city: '',
				receiver_subdistrict: '',
			},
		}
	},
	computed:{
		...mapState('opsi', ['provinces', 'cities', 'subdistricts']),

	},
	props: {
	},
	methods :{
		...mapActions('opsi', ['getProvince', 'getCity', 'getSubdistrict']),

		modalShow() {
			this.dialog = true
			this.getProvince()
			setTimeout(() => {
				this.$refs.receiver_name.focus()
			}, 200);
		},
		modalHide() {
			this.dialog = false
			this.$refs.formAddress.resetValidation()
			this.reset()
		},
		reset() {
			this.params.receiver_name = ''
			this.params.receiver_phone = ''
			this.params.receiver_address = ''
			this.params.receiver_province = ''
			this.params.receiver_city = ''
			this.params.receiver_subdistrict = ''
		},
		customFilter (item, queryText) {
			const byName = item.city_name.toLowerCase()
			const byType = item.city_type.toLowerCase()
			const searchText = queryText.toLowerCase()

			return byName.indexOf(searchText) > -1 || byType.indexOf(searchText) > -1
		},
		getCityAddress() {
			this.params.receiver_city = ''
			this.params.receiver_subdistrict = ''
			this.getCity({ province_id: this.params.receiver_province.province_id })
		},
		getSubdistrictAddress() {
			this.params.receiver_subdistrict = ''
			this.getSubdistrict({ city_id: this.params.receiver_city.city_id })
		},
		saveAddress() {
			if (this.$refs.formAddress.validate()) {
				this.$emit('action', this.params)
				this.modalHide()
			}
		},
	},
	created() {
	},
};
</script>